import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumnWideHalfAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"column-wide-half-add"} maskId="square-filled-radius-0-stroke-1-IconColumnWideHalfAdd"><path d="M2 4V20H13V19H3V12.5H22V4H2Z" fill="currentColor"/><path d="M20 16H19V19H16V20H19V23H20V20H23V19H20V16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconColumnWideHalfAdd;
